import TourPage from "@/components/TourPage";

export default function NyungweChimp2Day() {
  return (
    <TourPage
      tourId="rwanda/nyungwe-chimp-2-day"
      title="2 Days Nyungwe Chimpanzee Trekking Rwanda Safari"
      duration="2 Days / 1 Night"
      price="Contact for price"
      image="/chimpazeerwanda.jpeg"
      description="Rwanda's Nyungwe National Park on this 2-day adventure, featuring chimpanzee trekking and a canopy walk, takes you through the fascinating primal charm in their natural habitats."
      itinerary={[
        {
          day: 1,
          title: "Transfer to Nyungwe National Park and Canopy Walk Experience",
          description: "Journey to Nyungwe National Park and experience its famous canopy walk.",
          activities: [
            "Depart from Kigali and drive to Nyungwe National Park",
            "Visit the Royal Palace Museum and Ethnographic Museum",
            "En-route lunch and continue to Nyungwe National Park",
            "Canopy walk experience in Nyungwe National Park"
          ],
          accommodation: "Nyungwe Forest Lodge",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Nyungwe Chimpanzee Trekking and Transfer Back to Kigali",
          description: "Track chimpanzees in their natural habitat and return to Kigali.",
          activities: [
            "Early morning breakfast and chimpanzee trekking briefing",
            "Chimpanzee trekking in Nyungwe National Park",
            "One hour with the chimpanzees",
            "Lunch at the hotel and transfer back to Kigali",
            "Drop-off at the airport or hotel"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "All meals (breakfast, lunch, and dinner)",
        "All park entrance fees and permits",
        "All activities, including chimpanzee trekking and canopy walk",
        "Accommodation for 1 night",
        "Professional driver guide",
        "All transportation and airport transfers (4x4 luxury vehicle)"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "Tip",
        "Coffee, soft drinks, snacks, and drinking water (on all days)",
        "Government-imposed increase of taxes and/or park fees"
      ]}
    />
  );
}
